/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Invoice-translation admin list and editor.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminListModule} from '../common/directives/admin-list.module';
import {CodemirrorModule} from '../common/directives/codemirror.module';
import {InvoiceTranslationEditPageComponent} from './invoice-translation-edit-page.component';
import {InvoiceTranslationListPageComponent} from './invoice-translation-list-page.component';
import {InvoiceTranslationRoutePageComponent} from './invoice-translation-route-page.component';

const INVOICE_TRANSLATION = [
  InvoiceTranslationEditPageComponent,
  InvoiceTranslationListPageComponent,
  InvoiceTranslationRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    CodemirrorModule
  ],
  declarations: INVOICE_TRANSLATION,
  exports: INVOICE_TRANSLATION
})
export class InvoiceTranslationModule {
}
